// ============================================
// ALPHA OPTIONS - MAIN APP v3.1 (SaaS Edition)
// With Authentication, Subscriptions, and Routing
// ============================================

import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ClerkProvider, SignedIn, SignedOut } from '@clerk/clerk-react';
import { UserProvider } from './contexts/UserContext';

// Pages
import { LandingPage } from './pages/LandingPage';
import { LoginPage } from './pages/LoginPage';
import { SignupPage } from './pages/SignupPage';
import { DashboardPage } from './pages/DashboardPage';
import { ScannerPage } from './pages/ScannerPage';
import { PricingPage } from './pages/PricingPage';
import { TradeAdvisorPage } from './pages/TradeAdvisorPage';
import MoonshotPage from './pages/MoonshotPage';
import { GuidePage } from './pages/GuidePage';
import { PositionsPage } from './pages/PositionsPage';
import { ResearchEnginePage } from './pages/ResearchEnginePage';

// Clerk publishable key from environment
const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY || '';

if (!CLERK_PUBLISHABLE_KEY) {
  console.warn('Missing VITE_CLERK_PUBLISHABLE_KEY environment variable');
}

const App: React.FC = () => {
  return (
    <ClerkProvider publishableKey={CLERK_PUBLISHABLE_KEY}>
      <UserProvider>
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/guide" element={<GuidePage />} />

            {/* Protected Routes */}
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/scanner" element={<ScannerPage />} />
            <Route path="/advisor" element={<TradeAdvisorPage />} />
            <Route path="/moonshot" element={<MoonshotPage />} />
            <Route path="/positions" element={<PositionsPage />} />
            <Route path="/research" element={<ResearchEnginePage />} />

            {/* Catch-all redirect */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </UserProvider>
    </ClerkProvider>
  );
};

export default App;
